import {
    INITIATE_CALL,
    CREATE_CALL,
    RECEIVE_CALL,
    ANSWER_CALL,
    ANSWER_CALL_RECEIVED,
    CLOSE_CALL,
    CALL_DATA,
    CALL_POPUP,
    SEND_ICE_CANDIDATE,
    RECEIVE_ICE_CANDIDATE,
    END_CALL,
    CLEAR_CALL,
    CALL_ACKNOWLEDGE,
    RECEIVE_ACKNOWLEDGE,
    SET_VICI_SESSION,
    CLEAR_VICI_SESSION,
    VICI_ACKNOWLEDGE,
    RECEIVE_VICI_ACKNOWLEDGE,
} from 'App/store/constants';

const initialState = {
    receiveAckMsg: null,
    callAckMsg: null,
    callStatus: null,
    callActive: null,
    callType: null,
    callOffer: null,
    callAnswer: null,
    callAnswerReceived: null,
    candidate: null,
    sendIceCandidate: null,
    receiveIceCandidate: null,
    callPopup: null,
    call: null,
    loading: false,
    callEnd: null,
    viciSession: null,
    viciAckMsg: null,
    receiveViciAckMsg: null,
};

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case CALL_POPUP:
            console.log('Socket Reducer CALL_POPUP');
            return { ...state, callPopup: action.payload };

        case CALL_DATA:
            console.log('Socket Reducer CALL_DATA');
            return {
                ...state,
                call: action.payload,
                callEnd: false,
                viciSession: action.payload?.type === 'vici' ? state.viciSession : null,
            };
        // pending => initiate => waiting => replied => confirmed or rejected =>
        case INITIATE_CALL:
            console.log('Socket Reducer INITIATE_CALL');
            return {
                ...state,
                callStatus: 'initiate',
                callType: 'outgoing',
            };

        case CREATE_CALL:
            console.log('Socket Reducer CREATE_CALL');
            return {
                ...state,
                callActive: 'pending',
                receiveAckMsg: 'Calling...',
                callStatus: 'initiate',
                callOffer: action.payload,
            };

        case RECEIVE_ACKNOWLEDGE:
            return {
                ...state,
                receiveAckMsg: "Ringing ...",
                callAckMsg: null,
            }

        case CALL_ACKNOWLEDGE:
            return {
                ...state,
                callAckMsg: "Connected"
            }
        case RECEIVE_CALL:
            console.log('Socket Reducer RECEIVE_CALL');
            return {
                ...state,
                callActive: 'pending',
                callType: 'incoming',
                callStatus: 'waiting',
                callOffer: action.payload,
            };

        case ANSWER_CALL:
            console.log('Socket Reducer ANSWER_CALL');
            return {
                ...state,
                callStatus: 'replied',
                callActive: 'started',
                callAnswer: action.payload,
                loading: true,
            };

        case ANSWER_CALL_RECEIVED:
            console.log('Socket Reducer ANSWER_CALL_RECEIVED');
            return {
                ...state,
                callStatus: 'answered',
                callActive: 'started',
                callAnswerReceived: action.payload,
                loading: true,
            };

        case SEND_ICE_CANDIDATE:
            console.log('Socket Reducer SEND_ICE_CANDIDATE');
            return {
                ...state,
                //callStatus: 'answered',
                // callActive: 'started',
                sendIceCandidate: action.payload,
                loading: true,
            };

        case RECEIVE_ICE_CANDIDATE:
            console.log('Socket Reducer RECEIVE_ICE_CANDIDATE');
            return {
                ...state,
                //callStatus: 'answered',
                // callActive: 'started',
                receiveIceCandidate: action.payload,
                loading: true,
            };

        case CLOSE_CALL:
            return {
                ...state,
                callEnd: true,
            };

        case END_CALL:
            console.log('Socket Reducer CLOSE_CALL');
            return {
                ...state,
                call: null,
                receiveAckMsg: null,
                callAckMsg: null,
                callAnswer: null,
                candidate: null,
                sendIceCandidate: null,
                receiveIceCandidate: null,
                callActive: null,
                callStatus: null,
                callType: null,
                callOffer: null,
                callPopup: null,
                callEnd: null,
                viciSession: null,
            };

        case CLEAR_CALL:
            return { ...state, call: null, viciSession: null };

        case SET_VICI_SESSION:
            return { ...state, viciSession: action.payload };

        case CLEAR_VICI_SESSION:
            return { ...state, viciSession: null, viciAckMsg: null, receiveViciAckMsg: null };

        case VICI_ACKNOWLEDGE:
            return { ...state, viciAckMsg: action.payload };

        case RECEIVE_VICI_ACKNOWLEDGE:
            return { ...state, receiveViciAckMsg: action.payload };

        default:
            return state;
    }
};

export default reducer;
